export default "<div class=\"banner-pro\">\r\n    <img src=\"assets/images/background/banerce.jpg\" alt=\"\">\r\n</div>\r\n"